import {image_target_type_t} from '@zappar/zappar-cv';
import { IAreaTypes, ITuple3, IUnitTypes } from './general';
import { IGrabAndGoOptions } from './grabAndGo';

export enum ITrackingTypes {
	image = 'image',
	face = 'face',
	world = 'world',
	noTrackingScreen = 'noTrackingScreen',
	content360 = 'content360'
}

export enum IImageTrackingOrientation {
	upright = 'upright',
	flat = 'flat'
}

export interface ITargetAreaData {
	heightInMm?: number;
	targetArea?: IAreaTypes;
}

export interface ITrackingImageData {
	filestoreId?: string;
    id: string;
    fileName: string;
	orientation: IImageTrackingOrientation;
	units: IUnitTypes;
	aspectRatio: number;
	opacity: number;
	startSceneId: string;
	targetAreaData: ITargetAreaData;
	scale?: ITuple3;
	targetType?: image_target_type_t;
	targetImageHeight?: number;
	targetImageWidth?: number;
	normalizationFactor?: number;
	topRadius?: number;
	bottomRadius?: number;
	sideLength?: number;
    lastUsed: string;
}

export interface ITrackingImageDataDict {
	[id: string]: ITrackingImageData;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IWorldTrackingData {
}

export type ITrackingContentDocByTrackingType = Partial<{
	grabAndGo?: IGrabAndGoOptions;
	[ITrackingTypes.image]: ITrackingImageDataDict;
	[ITrackingTypes.world]: IWorldTrackingData;
}>

